import styled, { css } from 'styled-components';
import { colors } from '@/globalStyles';
import store from '@/store';
import { SMARTPHONE } from '@/constants';

export const InputWrapper = styled.div`
  display: none;
  width: 100vw;
  height: 50px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.backgroundInput};
  
  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          display: flex;
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const IconWrapper = styled.div`
  width: 50px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
